// This file was automatically generated from ptdata.model.order.referral.html.
// Please don't edit this file by hand.

goog.provide('el8.template.ptdata.model.order.referral');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.order.referral.refPanelSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.specialtyId) ? soy.$$escapeHtml(opt_data.specialtyAbbreviation) + ' = ' + soy.$$escapeHtml(opt_data.shortConsultantName) : (opt_data.shortConsultantName) ? soy.$$escapeHtml(opt_data.shortConsultantName) : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.order.referral.feedSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('Referral', (opt_data.order.consultantName) ? ' to ' + soy.$$escapeHtml(opt_data.order.consultantName) + ((opt_data.order.specialtyName) ? ' (' + soy.$$escapeHtml(opt_data.order.specialtyName) + ')' : '') : '', (opt_data.order.clinicalReason) ? ' for: ' + (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.order.clinicalReason)) : soy.$$escapeHtml(opt_data.order.clinicalReason)) : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.order.referral.patientSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('Referral to ', soy.$$escapeHtml(opt_data.consultantName), (opt_data.specialtyName) ? ' (' + soy.$$escapeHtml(opt_data.specialtyName) + ')' : '', (opt_data.clinicalReason) ? ' for: ' + (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.clinicalReason)) : soy.$$escapeHtml(opt_data.clinicalReason)) : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.order.referral.noteSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('Referral to ', soy.$$escapeHtml(opt_data.consultantName), (opt_data.clinicalReason) ? ' for ' + soy.$$escapeHtml(opt_data.clinicalReason) : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.order.referral.ownedDocSummaryTag = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('Referral:');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.order.referral.ownedDocSummaryReason = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.clinicalReason) ? '-- ' + soy.$$escapeHtml(opt_data.clinicalReason) + '.' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.order.referral.ownedDocSummaryConsultant = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append(soy.$$escapeHtml(opt_data.consultantName));
  if (!opt_sb) return output.toString();
};
